import { FC } from "react"
import { Outlet } from "react-router"
import { MainLayout } from "./MainLayout"

export const HomePage: FC = () => {
  return (
    <MainLayout>
      <Outlet />
    </MainLayout>
  )
}
